import {Pipe, PipeTransform} from '@angular/core';
import Fuse, { IFuseOptions } from 'fuse.js';

/**
 * Search pipe that filters an array of objects by searching across specified properties.
 * Uses Fuse.js for fuzzy matching with case-insensitive search.
 *
 * Usage: items | search:'property1,property2':searchTerm
 *
 * Example: fields | search:'name,field,description,example':filterText
 *
 * The pipe supports searching across any string properties including optional ones.
 * Properties that are undefined or null are gracefully skipped during search.
 */
@Pipe({
  name: 'search',
  standalone: false
})
export class SearchPipe implements PipeTransform {
  public transform(value: any, keys: string, term: string) {
    if (!term) {
      return value;
    }
    const fuseOptions: IFuseOptions<any> = {
      shouldSort: true,
      findAllMatches: true,
      threshold: 0.4, // Lower threshold for more inclusive matching (0 = exact, 1 = match anything)
      ignoreLocation: true, // Search the entire string, not just the beginning
      minMatchCharLength: 2 // Minimum characters to match
    };
    if (keys) {
      fuseOptions.keys = keys.split(',');
    }
    const fuse = new Fuse(value, fuseOptions);
    return fuse.search(term).map(r => r.item);
  }
}
